import React from 'react'
import * as DropdownPrimitive from '@radix-ui/react-dropdown-menu'
import {
  StyledContent,
  StyledItem,
  StyledLabel,
  StyledSeparator,
  StyledSubContent,
  StyledSubTrigger,
  Shortcut,
} from './style'
import { Check, ChevronRight, Circle } from 'lucide-react'

export function DropdownMenu(props) {
  return <DropdownPrimitive.Root {...props} />
}

export function DropdownMenuTrigger(props) {
  return <DropdownPrimitive.Trigger {...props} />
}

export const DropdownMenuContent = React.forwardRef((props, ref) => {
  return <StyledContent ref={ref} sideOffset={4} {...props} />
})

export function DropdownMenuGroup(props) {
  return <DropdownPrimitive.Group {...props} />
}

export const DropdownMenuItem = React.forwardRef(({ inset, variant, ...props }, ref) => {
  return <StyledItem ref={ref} data-inset={inset} data-variant={variant} {...props} />
})

export const DropdownMenuLabel = React.forwardRef((props, ref) => <StyledLabel ref={ref} {...props} />)
export const DropdownMenuSeparator = React.forwardRef((props, ref) => <StyledSeparator ref={ref} {...props} />)

export function DropdownMenuSub(props) {
  return <DropdownPrimitive.Sub {...props} />
}

export const DropdownMenuSubTrigger = React.forwardRef(({ children, inset, ...props }, ref) => (
  <StyledSubTrigger ref={ref} data-inset={inset} {...props}>
    {children}
    <ChevronRight size={14} style={{ marginLeft: 'auto' }} />
  </StyledSubTrigger>
))

export const DropdownMenuSubContent = React.forwardRef((props, ref) => <StyledSubContent ref={ref} {...props} />)

export { Shortcut as DropdownMenuShortcut } 